var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.91 9.19C1.58 9.19.5 8.359.5 7.137s1.08-2.212 2.41-2.212c.091 0 .18.005.269.013v-.013h.033a3.647 3.647 0 0 1-.033-.492C3.179 2.261 5.097.5 7.464.5c1.603 0 3 .807 3.736 2.003.18-.024.363-.037.55-.037 2.071 0 3.75 1.54 3.75 3.441 0 1.564-1.138 2.757-2.695 3.15m-4.923 3.11V6.522m0 0L5.422 8.85m2.46-2.328 2.462 2.328"
  })));
};
export default SvgUpload;